//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ALayoutSider from "ant-design-vue/es/layout/Sider";
import SMenu from "./index";
import { mixin, mixinDevice } from '@/utils/mixin.js';
export default {
  name: "SideMenu",
  components: {
    ALayoutSider: ALayoutSider,
    SMenu: SMenu
  },
  mixins: [mixin, mixinDevice],
  props: {
    mode: {
      type: String,
      required: false,
      default: 'inline'
    },
    theme: {
      type: String,
      required: false,
      default: 'light'
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    menus: {
      type: Array,
      required: true
    }
  },
  computed: {
    smenuStyle: function smenuStyle() {
      var style = {
        'padding': '0'
      };

      if (this.fixSiderbar) {
        style['height'] = 'calc(100% - 59px)';
        style['overflow'] = 'auto';
        style['overflow-x'] = 'hidden';
      }

      return style;
    }
  },
  mounted: function mounted() {
    console.log(this.menus);
  },
  methods: {
    onSelect: function onSelect(obj) {
      console.log("----------sideMenu onSelect----------");
      this.$emit('menuSelect', obj);
    }
  }
};